import { isTextNode, isElementNode } from 'anodum';
import instance from '../instance';
import getLiveElement from './get-live-element';

const getLiveElementByCoords = (x, y) => {
  const document = instance.driver.getLiveDocument();
  const targetElement = document.elementFromPoint(x, y);

  if (
    isTextNode(targetElement) ||
    (isElementNode(targetElement) && !instance.driver.referenceMap.hasReference(targetElement))
  ) {
    return getLiveElement(instance.driver.referenceMap.getClosestReferenceId(targetElement));
  }

  return targetElement;
};

export default getLiveElementByCoords;
